import React from 'react'
import { Tooltip } from 'antd' ;
import { Button } from 'antd';

import x_axis_icon from './images/x_axis_icon.png' 
import y_axis_icon from './images/y_axis_icon.png' 
import z_axis_icon from './images/z_axis_icon.png' 

import alt_x_axis_icon from './images/alt_x_axis_icon.png' 
import alt_y_axis_icon from './images/alt_y_axis_icon.png' 
import alt_z_axis_icon from './images/alt_z_axis_icon.png' 


import { TOP_BUTTON_STYLE } from './constants.js'
import { TT_BGCOLOR } from './constants.js'

import { V3DSpace } from './App'

const DBL_CLICK_TIME = 350

class Camera_Align extends React.Component
    {
    constructor (props)
        {
        super (props) ;

        this.state = {
            x_click_timeout: null,
            y_click_timeout: null,
            z_click_timeout: null,
            x_icon: x_axis_icon,
            y_icon: y_axis_icon,
            z_icon: z_axis_icon,
            }

        this._last_click_time = 0

        const handle_off_axis = () => 
            {
            this.setState ({
                x_icon: x_axis_icon,
                y_icon: y_axis_icon, 
                z_icon: z_axis_icon, 
                })    
            }

        document.addEventListener ('off_axis', handle_off_axis)
        
        this.set_viewaxis_x = this.set_viewaxis_x.bind (this) 
        this.set_viewaxis_y = this.set_viewaxis_y.bind (this) 
        this.set_viewaxis_z = this.set_viewaxis_z.bind (this) 
        }

    set_viewaxis_x ()
        {
        /*
        const handle_off_axis = () =>
            {
            document.removeEventListener ('off_axis', handle_x_off_axis)

            this.setState ({
                x_icon: x_axis_icon,
                y_icon: y_axis_icon, 
                z_icon: z_axis_icon, 
                })    
            }
        */
    
        // Check for the existence of the timer.  If we have have already started
        // the timer, than this is a doubleclick.  Otherwise, it just a solitary 
        // click which may -or may not- be followed by another.
        if  (this.state.x_click_timeout)
            {
            clearTimeout (this.state.x_click_timeout)

            V3DSpace.set_axis ("X", true)

            this.setState ({x_click_timeout: null, 
                x_icon: alt_x_axis_icon,
                y_icon: y_axis_icon,
                z_icon: z_axis_icon, 
                })                 
            }

        else 
            {
            const handle = setTimeout (() => {
                // Handle single-click logic here
                V3DSpace.set_axis ("X", false)
                
                this.setState ({
                    x_click_timeout: null, 
                    x_icon: x_axis_icon, 
                    y_icon: y_axis_icon, 
                    z_icon: z_axis_icon, 
                    })
                }, 
                DBL_CLICK_TIME)
    
            this.setState ({x_click_timeout: handle})
            }
        }

    set_viewaxis_y ()
        {
        // Check for the existence of the timer.  If we have have already started
        // the timer, than this is a doubleclick.  Otherwise, it just a solitary 
        // click which may -or may not- be followed by another.
        if  (this.state.y_click_timeout)
            {
            clearTimeout (this.state.y_click_timeout)

            V3DSpace.set_axis ("Y", true)

            this.setState ({y_click_timeout: null, 
                x_icon: x_axis_icon,
                y_icon: alt_y_axis_icon,
                z_icon: z_axis_icon, 
                })            
            }

        else 
            {
            const handle = setTimeout (() => {
                // Handle single-click logic here
                V3DSpace.set_axis ("Y", false)
                
                this.setState ({
                    y_click_timeout: null, 
                    x_icon: x_axis_icon, 
                    y_icon: y_axis_icon, 
                    z_icon: z_axis_icon, 
                    })
                }, 
                DBL_CLICK_TIME)
    
            this.setState ({y_click_timeout: handle})
            }
        }

    set_viewaxis_z ()
        {
        // Check for the existence of the timer.  If we have have already started
        // the timer, than this is a doubleclick.  Otherwise, it just a solitary 
        // click which may -or may not- be followed by another.
        if  (this.state.z_click_timeout)
            {
            clearTimeout (this.state.z_click_timeout)

            V3DSpace.set_axis ("Z", true)

            this.setState ({z_click_timeout: null,  
                x_icon: x_axis_icon,
                y_icon: y_axis_icon,
                z_icon: alt_z_axis_icon, 
                })                        
            }

        else 
            {
            const handle = setTimeout (() => {
                // Handle single-click logic here
                V3DSpace.set_axis ("Z", false)
                
                this.setState ({
                    z_click_timeout: null, 
                    x_icon: x_axis_icon, 
                    y_icon: y_axis_icon, 
                    z_icon: z_axis_icon, 
                    })
                }, 
                DBL_CLICK_TIME)
    
            this.setState ({z_click_timeout: handle})
            }
        }

    render ()
        {    
        const x_align_button =
            <Tooltip    placement="bottom" 
                color={TT_BGCOLOR}
                title="Align view to the X axis.">
                <Button
                    size="small"
                    type="ghost"
                    onClick={this.set_viewaxis_x} 
                    style={TOP_BUTTON_STYLE}
                    >
                    <img src={this.state.x_icon} className= "icon_image" alt="" />
                </Button>
            </Tooltip> ;

        const y_align_button =
            <Tooltip    placement="bottom" 
                color={TT_BGCOLOR}
                title="Align view to the Y axis.">
                <Button
                    size="small"
                    type="ghost"
                    onClick={this.set_viewaxis_y} 
                    style={TOP_BUTTON_STYLE}
                    >
                    <img src={this.state.y_icon} className= "icon_image" alt="" />
                </Button>
            </Tooltip> ;

        const z_align_button =
            <Tooltip    placement="bottom" 
                color={TT_BGCOLOR}
                title="Align view to the Z axis.">
                <Button
                    size="small"
                    type="ghost"
                    onClick={this.set_viewaxis_z} 
                    style={TOP_BUTTON_STYLE}
                    >
                    <img src={this.state.z_icon} className= "icon_image" alt="" />
                </Button>
            </Tooltip> ;
                
         return (
            <div className="center_controls">
                <div className="camera_align_controls">
                    {x_align_button}
                    {y_align_button}
                    {z_align_button}
                </div>
                <div className='target_label'>
                    {this.props.focus_label}
                </div>
            </div>


            ) ;
        }
    }

    export default Camera_Align